import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import QuoteChatScreen from "components/QuoteChatScreen";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useTranslation from "hooks/Translation";
import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const QuoteChat = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const location = useLocation();
  const { state } = location;
  console.log(state);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        // variant="gradient"
        sx={{ display: "flex", justifyContent: "space-between" }}
        // textAlign="center"
      >
        <div></div>
        <MDBox
          // variant="gradient"
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          p={1}
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/managing-quotes")}
          // textAlign="center"
        >
          <MDTypography variant="h6" color="white">
            {t.main.back}{" "}
          </MDTypography>
        </MDBox>
      </MDBox>
      <QuoteChatScreen sessionId={state?.sessionId} />
    </DashboardLayout>
  );
};

export default QuoteChat;
